import GeneratedProjectTemplateServiceApi from "./generated/GeneratedProjectTemplateServiceApi"

class ProjectTemplateServiceApi extends GeneratedProjectTemplateServiceApi {

}

export const projectTemplateServiceApi = new ProjectTemplateServiceApi()
